import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const SsoPage = lazy(() => import('~/features/organization/pages/sso-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/sso')({
  beforeLoad: requirePermission('organization_sso'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SsoPage />
    </Suspense>
  ),
});
